import ActionTypeZona from "../ActionTypeZona";
// import {ModosOp} from '../../../../isp._comun/iu/_principal/constantesIuPrin'// import Estado from '../../EstadoDialogoClienteAFacturar'
import ActionZonaSet from "../ActionZonaSet";

export default class CargaDeZonaRegistrado extends ActionTypeZona {
    ejecutar(estado, nuevoEstado) {
        // nuevoEstado.input.domain.rowSelected = null;
        // nuevoEstado.input.domain.indexRowSelected = null;
        // nuevoEstado.input.domain.nombre="";

        new ActionZonaSet("indexRowSelected", null).ejecutar(estado, nuevoEstado);
        new ActionZonaSet("rowSelected", null).ejecutar(estado, nuevoEstado);
        new ActionZonaSet("nombre", "").ejecutar(estado, nuevoEstado);

        // nuevoEstado.input.domain.idZona = this.payload.idZona;
        // nuevoEstado.domain.screen.fechaReg = this.payload.fechaReg;
        // nuevoEstado.domain.screen.estado = this.payload.estado;
        nuevoEstado.flag.procesandoComandoCrear = false;
        nuevoEstado.flag.procesandoComando = false;

        for (const property in estado.error) {
            nuevoEstado.error[property] = false;
        }

        nuevoEstado.output.domain.resultSet.push({idZona:this.payload.idZona, nombre:this.payload.nombre});
        nuevoEstado.flag.sensorMostrarFinalTabla=!estado.flag.sensorMostrarFinalTabla;



        // nuevoEstado.domain.cargado = JSON.parse(JSON.stringify(estado.domain.screen));
        // delete nuevoEstado.domain.cargado.idZona;
        // delete nuevoEstado.domain.cargado.fechaReg;
        // delete nuevoEstado.domain.cargado.estado;
        // nuevoEstado.domain.update = {};
        // nuevoEstado.domain.nroUpdates = 0;

        return nuevoEstado;
    }
}
